const ROUTE_PREFIX = ''

export function routePath( route = '' ) {
  if( route === '' ) {
    return `${ROUTE_PREFIX}`
  }
  return `${ROUTE_PREFIX}/${route}`
}